
<f-dialog
    v-model      = "edit"
    :width       = "dialogWidth < 800 ? dialogWidth : 800"
    :show-header = "true"
    title        = "Anlagen"
    :show-delete = "false"
    :hide-actions = "true"
    @cancel      = "onCancel"
>
    <template v-slot:content>
        <div class="v-flex mb-4 mt-2">
            <v-spacer />
            <v-btn
                class  = "dialog-button ml-3"
                color  = "primary"
                @click = "onErrors"
                style  = "width: 185px;"
            >
                {{ filter.errors ? $t("importer.filter.unit.errors.on") : $t("importer.filter.unit.errors.off") }}
            </v-btn>
        </div>

        <p-import-content
            id             = "import-units-id"
            :rows          = "units"
            :columns       = "columns"
            :size          = "{ x: dialogWidth < 800 ? dialogWidth : 800+75, y: 600 }"
            :show-units    = "false"
            :filter        = "filter"
            :scroll-width  = "dialogWidth"
            :right-padding ="0"
            :target-format = "true"
        />
    </template>
</f-dialog>
